<script>
  import Page from '@dabble/toolkit/Page.svelte';

  export let doc;
</script>

<Page {doc} />
